<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps" ref="SetBtn"></buttonlist>
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ConfigType" :label="$t('getapi[3191]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ConfigName" :label="$t('getapi[2078]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ConfigValue" :label="$t('getapi[3192]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Remarks" :label="$t('getapi[143]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="module" :label="$t('getapi[6050]')" width="100"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="60">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="edit(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog v-dialogDrag :title="$t('getapi[1067]')" :visible.sync="isShow" width="30%">
			<!--<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="150px" label-position="left" size="small">
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[2078]')"><el-input v-model="dataDetail.configname" :disabled="inner_flag != 1"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3192]')"><el-input v-model="dataDetail.configvalue" type="textarea"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[143]')"><el-input v-model="dataDetail.remarks" type="textarea" :disabled="inner_flag != 1"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[6050]')"><el-input v-model="dataDetail.module" :disabled="inner_flag != 1"></el-input></el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>-->
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[2078]')}}</td>
					<td><el-input v-model="dataDetail.configname" type="text" size="mini" :disabled="inner_flag != 1"></el-input></td>
					<td>{{$t('getapi[3192]')}}</td>
					<td><el-input v-model="dataDetail.configvalue" type="textarea" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataDetail.remarks" type="textarea" size="mini" :disabled="inner_flag != 1"></el-input></td>
					<td>{{$t('getapi[6050]')}}</td>
					<td><el-input v-model="dataDetail.module" type="text" size="mini" :disabled="inner_flag != 1"></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isShow = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="small" type="primary" @click="save">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
		<serce :isVisible="isVisible" queryData="SYS_Config" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'config',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			user: '',
            inner_flag: 0,
			isVisible: false, // 查询列表是否显示
			isShow:false,
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 50, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			dataDetail: {},
			queryData: [], // 查询数组
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.user = that.userData.username;
		that.inner_flag = that.userData.inner_flag;
		// that.getView();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1067]"),this.$t("getapi[12]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.btn.edit = true;
			that.btn.del = true;
			that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
		},
		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, 'SYS_Config');
		},
		//获取查询条件
		serclick(val) {
			console.log(val);
			this.queryData = val;
			this.PageIndex = 1;
			this.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: 1,
				PageSize: 100000,
				Param: []
			};
			that.queryData.forEach(item => {
				pm = {
					row_sign: item.row_sign,
					query_Condition: item.query_Condition,
					query_sort: item.query_sort,
					query_field_type: item.Query_Field_Type,
					query_field_name: item.Query_Field_Name
				};
				parm.Param.push(pm);
			});
			that.$http.urlpost('/Sys/Currency/GetSysConfigList', parm, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent.Table;
					that.loading = false;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		edit(row) {
			let that = this;
			that.isShow = true;
			let parm = {
				Code: row.ConfigType
			};
			that.$http.urlpost('/Sys/Currency/GetSysConfigInfo', parm, function(res) {
				if (res.Success == 1) {
					that.dataDetail = res.DataContent;
				}
			});
		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: [],
                LangType:that.$processdata.getLang(),
                fromname: that.$t('getapi[1067]')
			};
			that.queryData.forEach(item => {
				pm = {
					row_sign: item.row_sign,
					query_Condition: item.query_Condition,
					query_sort: item.query_sort,
					query_field_type: item.Query_Field_Type,
					query_field_name: item.Query_Field_Name
				};
				parm.Param.push(pm);
			});
			that.$http.urlpost('/Sys/Currency/SysConfigExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		save() {
			let that = this;
			let arr = [];
			arr = [...arr, that.dataDetail];
			let parm = arr;
			that.$http.urlpost('/Sys/Currency/SaveSysConfig', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
					that.getView();
					that.isShow=false;
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
.el-textarea {
	display: block;
}
</style>
